if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        console.log('onSubmitHandler:', this.dataset);
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';



        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        const response = await fetch("/cart.json").then(res => res.json());
        delete config.headers['Content-Type'];

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }
            if (this.closest('#checkout-section')) {
              window.location.href = '/checkout';
              return;
            }
            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              fetch("/cart.json").then(res => res.json()).then(cart => {
                if (!this.hasAttribute("data-disable-cart")) {
                  this.cart.renderContents(response);
                } else {
                  document.querySelector("#cart-icon-bubble").innerHTML = this.cart.getSectionInnerHTML(response.sections["cart-icon-bubble"]);
                  document.querySelector("#CartDrawer").innerHTML = this.cart.getSectionInnerHTML(response.sections["cart-drawer"], "#CartDrawer");
                }

              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

if (!customElements.get('show-more-media-gallery')) {
  customElements.define(
    'show-more-media-gallery',
    class ShowMoreMediaGallery extends HTMLElement {
      constructor() {
        super();
        this.isExpaned = false;
        this.mediaGallery = this.querySelector('media-gallery > slider-component');
        this.mediaGallery.style = `max-height: ${this.mediaGallery.offsetWidth}px; overflow: hidden;`;
        this.querySelector('#showMoreGallery').addEventListener('click', this.showMoreToggle.bind(this));
      }

      showMoreToggle() {
        this.isExpaned = !this.isExpaned;
        if (this.isExpaned) {
          this.mediaGallery.style = `max-height: none; overflow: none;`;
          this.querySelector('#showMoreGallery').textContent = 'POKAŻ MNIEJ';
        } else {
          this.mediaGallery.style = `max-height: ${this.mediaGallery.offsetWidth}px; overflow: hidden;`;
          this.querySelector('#showMoreGallery').textContent = 'POKAŻ WIĘCEJ';
        }
      }
    }
  );
}

if (!customElements.get('media-zommable')) {
  customElements.define(
    'media-zommable',
    class Zoomable extends HTMLElement {
      constructor() {
        super();
        this.zoomed = false;
        this.element = this;
        this.config = {
          initialZoom: 3,
          minZoom: 1.25,
          maxZoom: 4,
          zoomSpeed: 0.01,
        };

        const { initialZoom, minZoom, maxZoom } = this.config;

        this.initialZoom = Math.max(Math.min(initialZoom, maxZoom), minZoom);
        this.zoom = this.initialZoom;

        this.img = this.querySelector('.zoomable__img');
        this.img.draggable = false;
        this.element.style.setProperty('--zoom', this.initialZoom);

        this._addEventListeners();
      }

      static get Default() {
        return {
          initialZoom: 3,
          minZoom: 1.25,
          maxZoom: 4,
          zoomSpeed: 0.01,
        };
      }

      _addEventListeners() {
        //this.element.addEventListener("mouseover", () =>
        // this._handleMouseover()
        //);

        this.element.addEventListener('click', () => this._toggleZoom());

        this.element.addEventListener('mousemove', (evt) => this._handleMousemove(evt));
        this.element.addEventListener('mouseout', () => this._handleMouseout());
        this.element.addEventListener('wheel', (evt) => this._handleWheel(evt));
      }

      _handleMouseover() {
        if (this.zoomed) {
          return;
        }

        this.element.classList.add('zoomable--zoomed');

        this.zoomed = true;
      }

      _toggleZoom() {
        this.zoomed = !this.zoomed;
        if (this.zoomed) {
          this.element.classList.add('zoomable--zoomed');
        } else {
          this.element.classList.remove('zoomable--zoomed');
          this.element.style.setProperty('--zoom', this.initialZoom);
        }
      }

      _handleMousemove(evt) {
        if (!this.zoomed) {
          return;
        }

        const elPos = this.element.getBoundingClientRect();

        const percentageX = `${((evt.clientX - elPos.left) * 100) / elPos.width}%`;
        const percentageY = `${((evt.clientY - elPos.top) * 100) / elPos.height}%`;

        this.element.style.setProperty('--zoom-pos-x', percentageX);
        this.element.style.setProperty('--zoom-pos-y', percentageY);
      }

      _handleMouseout() {
        if (!this.zoomed) {
          return;
        }

        this.element.style.setProperty('--zoom', this.initialZoom);
        this.element.classList.remove('zoomable--zoomed');

        this.zoomed = false;
      }

      _handleWheel(evt) {
        if (!this.zoomed) {
          return;
        }

        evt.preventDefault();

        const newZoom = this.zoom + evt.deltaY * (this.config.zoomSpeed * -1);
        const { minZoom, maxZoom } = this.config;

        this.zoom = Math.max(Math.min(newZoom, maxZoom), minZoom);
        this.element.style.setProperty('--zoom', this.zoom);
      }

      _handleTouchstart(evt) {
        evt.preventDefault();

        this._handleMouseover();
      }

      _handleTouchmove(evt) {
        if (!this.zoomed) {
          return;
        }

        const elPos = this.element.getBoundingClientRect();

        let percentageX = ((evt.touches[0].clientX - elPos.left) * 100) / elPos.width;
        let percentageY = ((evt.touches[0].clientY - elPos.top) * 100) / elPos.height;

        percentageX = Math.max(Math.min(percentageX, 100), 0);
        percentageY = Math.max(Math.min(percentageY, 100), 0);

        this.element.style.setProperty('--zoom-pos-x', `${percentageX}%`);
        this.element.style.setProperty('--zoom-pos-y', `${percentageY}%`);
      }

      _handleTouchend(evt) {
        this._handleMouseout();
      }

      _mergeConfig(config) {
        return {
          ...this.constructor.Default,
          ...(typeof config === 'object' ? config : {}),
        };
      }
    }
  );
}



const updateCartSection = () => {
  const sectionUrl = '?section_id=peta-wrapper';

  fetch(sectionUrl)
    .then(response => response.text())
    .then(htmlString => {
      const parser = new DOMParser();
      const html = parser.parseFromString(htmlString, 'text/html');
      const cartItemsSection = html.querySelector('.discount-message--wrapper');
      const galleryItem = html.querySelector('.discount-message--wrapper-gallery');

      if (cartItemsSection) {
        document.querySelector('.discount-message--wrapper').innerHTML = cartItemsSection.innerHTML;
      }

      if (galleryItem) {
        document.querySelector('.discount-message--wrapper-gallery').innerHTML = galleryItem.innerHTML;
      }
    })
    .catch(error => console.error('Error updating cart section:', error));
};

// Subscribe to the cart update event
subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
  console.log('Cart updated:', event);
  updateCartSection();
});